export const send = `
<svg height="48" viewBox="0 0 48 48" width="48" fill="#ffff"  xmlns="http://www.w3.org/2000/svg">
    <path fill="#FFFF" d="M4.02 42l41.98-18-41.98-18-.02 14 30 4-30 4z"/>
    <path d="M0 0h48v48h-48z" fill="none"/>
</svg>
`;
